// @core/api/endpoints/billing/list_transactions.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListTransactionsResponse,
} from '../../../types/billing';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/billing';

/**
 * List transactions
 * Returns a paginated list of accounting transaction records with optional filtering by billing account, status, type, and date range.
 */
export async function ListTransactions(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListTransactionsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/transactions`;
  const requestOptions = options;
  return client.get<ListTransactionsResponse>(requestPath, { ...requestOptions, params });
}
